import { Tab } from "@blueprintjs/core";
import * as React from "react";
import { useQuery } from "react-query";
import { useHistory, useParams } from "react-router";

import { ProfileAbsencesPage, ProfileDetailPage, ProfileMetiersPage } from ".";
import { UtilisateurApi } from "../../../api";
import { ERoutes } from "../../../AppRouter";
import { BackButton, PageBase, ProtectedTabs } from "../../../components";
import { useAuth } from "../../../contexts";
import { useApiService, useTl } from "../../../hooks";
import { ETLCodes } from "../../../locales";

export interface IUserProfileItemPageProps {}

export const UserProfileItemPage: React.FunctionComponent<IUserProfileItemPageProps> = props => {
  const { t } = useTl();
  const { user } = useAuth();
  const { id, tab, state } = useParams<{ id: string; tab: string; state: string }>();
  const history = useHistory();
  const api = useApiService(UtilisateurApi);

  React.useEffect(() => {
    if (user?.iduser !== +id && user.hopeMainLevelName !== "CALC" && !user.isAdmin) history.push(ERoutes.unauthorized);
  }, [history, id, user.hopeMainLevelName, user?.iduser, user.isAdmin]);

  const fetchDisplayName = React.useCallback(() => {
    return api.utilisateurGetDisplayName({ id: +id });
  }, [id, api]);
  const { data: displayName } = useQuery(["user-display-name", id], fetchDisplayName);

  return (
    <PageBase breadCrumbs={[{ text: t(ETLCodes.Profil), route: ERoutes.profile }, { text: displayName }]}>
      <ProtectedTabs
        id="TabsProfiles"
        onChange={newTabId => history.push(`${ERoutes.profile}/${id}/${newTabId}/${state}`)}
        selectedTabId={tab}
        renderActiveTabPanelOnly
      >
        <BackButton backRoute={ERoutes.profile}></BackButton>
        <Tab id="detail" title={t(ETLCodes.Detail)} panel={<ProfileDetailPage />} />
        <Tab id="metiers" title={t(ETLCodes.MetiersLocalites)} panel={<ProfileMetiersPage />} disabled={+id <= 0} />
        <Tab id="absences" title={t(ETLCodes.Absences)} panel={<ProfileAbsencesPage />} disabled={+id <= 0} />
      </ProtectedTabs>
    </PageBase>
  );
};

export default UserProfileItemPage;
